import CheckoutBankSlip from './checkout-bank-slip.vue';

export default CheckoutBankSlip;
